import { render, staticRenderFns } from "./FactList.vue?vue&type=template&id=c28f3f4c&"
import script from "./FactList.vue?vue&type=script&lang=js&"
export * from "./FactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c28f3f4c')) {
      api.createRecord('c28f3f4c', component.options)
    } else {
      api.reload('c28f3f4c', component.options)
    }
    module.hot.accept("./FactList.vue?vue&type=template&id=c28f3f4c&", function () {
      api.rerender('c28f3f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FactList.vue"
export default component.exports